import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import axios from '@pepper/utils/src/function/axiosInstance'
import extract from '@pepper/utils/src/function/extract'

export const fetchDomainValidation = async ({
  companyId,
  url,
  isAccessible = false,
  isValidGscDomain = false,
}: {
  companyId: string
  url: string | string[]
  isAccessible?: boolean
  isValidGscDomain?: boolean
}): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/domains/valid`,
      {
        urls: Array.isArray(url) ? url : [url],
        is_accessible: isAccessible,
        is_valid_gsc_domain: isValidGscDomain,
      }
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const addDomains = async ({
  companyId,
  url,
  competitors,
  country_code,
  brand_keywords,
  ga_property,
  gsc_domain_property,
}: {
  companyId: string
  url: string
  competitors?: string[]
  country_code?: string
  brand_keywords?: string[]
  gsc_domain_property?: string
  ga_property?: string
}): Promise<ApiResponse> => {
  try {
    const response = await axios.post(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/domains`,
      {
        url,

        competitors,
        country_code,
        brand_keywords,
        ga_property,
        gsc_domain_property,
      }
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export type UpdateDomainPayload = {
  companyId: string
  domainId: string
  ga?: string
  gsc?: string
}

export const updateDomain = async ({
  companyId,
  domainId,
  ga,
  gsc,
}: UpdateDomainPayload): Promise<ApiResponse> => {
  try {
    const response = await axios.put(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/domains/${domainId}`,
      {
        ga_property: ga,
        gsc_domain_property: gsc,
      }
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const getDomainsIntersection = async ({
  companyId,
}: {
  companyId: string
}): Promise<ApiResponse> => {
  try {
    const response = await axios.get(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/domains/intersect`
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export const deleteDomain = async (
  companyId: string,
  domainId: string
): Promise<ApiResponse> => {
  try {
    const response = await axios.delete(
      `${SEO_SERVICE_BASE_URL}/companies/${companyId}/domains/${domainId}`
    )
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
